/**
 * 页面与上下文的映射关系
 * 用于自动注入上下文数据
 */

/**
 * 页面与上下文的映射关系
 */
export const PAGE_CONTEXTS: Record<string, string[]> = {
  搜索结果页: ["search", "page"],
  专题页: ["search", "page"],
  主题页: ["search", "page"],
  相似商用素材页: ["search", "page"],
  相似素材推荐页: ["search", "page"],
  采集详情页: ["pin_detail", "page", "search"], // 采集详情页也需要搜索上下文
  画板详情页: ["board", "page"],
  个人主页: ["user", "page"],
  首页: ["page"],
  发现页: ["page"],
  // ... 可以根据需要添加更多页面
};

/**
 * 获取页面需要的上下文类型
 */
export function getPageContextTypes(pageName: string): string[] {
  return PAGE_CONTEXTS[pageName] || ["page"];
}

/**
 * 判断页面是否需要某种上下文
 */
export function needsContext(pageName: string, contextType: string): boolean {
  const contexts = getPageContextTypes(pageName);
  return contexts.includes(contextType);
}

/**
 * 判断是否是搜索相关页面
 */
export function isSearchPage(pageName: string): boolean {
  return needsContext(pageName, "search");
}

/**
 * 判断是否是详情页
 */
export function isDetailPage(pageName: string): boolean {
  return needsContext(pageName, "pin_detail");
}
